import { useState } from "react";
import axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import "./login.css";

export default function Login() {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const navigate = useNavigate();

  const handleLogin = () => {

    if (!email || !password) {

      alert("Please fill all fields ❗");

      return;
    }

    axios.post(
      "https://apple2.shopat1stop.com/api/login",
      {
        email,
        password
      }
    )

    .then((res) => {

      if (!res.data.user_id) {

        alert(
          res.data.message ||
          "Login failed ❌"
        );

        return;
      }

      alert("Login successful ✅");

      localStorage.setItem(
        "user_id",
        res.data.user_id
      );

      localStorage.setItem(
        "token",
        res.data.token
      );

      localStorage.setItem(
        "name",
        res.data.name || ""
      );

localStorage.setItem(
  "role",
  res.data.role
);


      setEmail("");
      setPassword("");

      navigate("/");

    })

    .catch((err) => {

      alert(
        err.response?.data?.message ||
        "Login failed ❌"
      );

    });

  };

  return (

    <div className="login-page">

      <div className="login-card">

        {/* LEFT SIDE */}
        <div className="login-left">

          <h1>
            🍃 Apple Smoke Shop
          </h1>

          <p>
            Premium THCA Flower,
            CBD Gummies, Vapes &
            Smoke Essentials
          </p>

        </div>

        {/* RIGHT SIDE */}
        <div className="login-right">

          <h2>
            Welcome Back 👋
          </h2>

          <p className="login-subtitle">
            Login to continue shopping
          </p>

          <input
            type="email"
            placeholder="Enter Email"
            value={email}
            onChange={(e) =>
              setEmail(e.target.value)
            }
          />

          <input
            type="password"
            placeholder="Enter Password"
            value={password}
            onChange={(e) =>
              setPassword(e.target.value)
            }
          />

          <button
            onClick={handleLogin}
          >
            Login
          </button>

          <div className="login-links">

            <Link to="/register">
              Create Account
            </Link>

          </div>

        </div>

      </div>

    </div>
  );
}